import { Component, HostListener } from "@angular/core";
import { ContextMenuService } from "./context-menu.service";
import { MenuPackage } from "./context-menu-injector";

@Component({
  selector: "app-menu",
  template: ``,
})
export class MenuComponent {
  _state: "void" | "enter" | "exit" = "enter";
  lazy = true;
  closeTimer: any;

  constructor(public menuPackage: MenuPackage, public contextMenuService: ContextMenuService) {}

  @HostListener("mouseover")
  handleMouseover() {
    if (!this.menuPackage.menu.submenu) return;
    this.menuPackage.menu.isMenuHovered.next(true);
    clearTimeout(this.closeTimer);
  }

  @HostListener("mouseleave")
  handleMouseleave() {
    if (!this.menuPackage.menu.submenu) return;
    this.menuPackage.menu.isMenuHovered.next(false);
    this.closeTimer = setTimeout(() => {
      this.contextMenuService.closeSubMenu(this.menuPackage.menu.id);
    }, 500);
  }

  @HostListener("document:click", ["$event"])
  handleWindowClick($event: MouseEvent) {
    this.contextMenuService.checkOutsideClick($event);
  }
}
